import Image from 'next/future/image';
import FilterIcon from '@/public/icons/collection/filterIcon.svg';
import SortSelect from './SortSelect';

const Filters = ({ setIsOpen }: { setIsOpen: (val: boolean) => void }) => (
  <div className="flex rounded-full border-2 border-gray-700 lg:hidden">
    <div
      onClick={() => setIsOpen(true)}
      className="flex flex-1 cursor-pointer items-center justify-center rounded-l border-r-2 border-gray-700 text-center text-sm outline-none lg:rounded"
    >
      <span className="mr-2 hidden 3xs:block">
        <Image
          src={FilterIcon}
          alt={FilterIcon}
          width={13}
          height={13}
          className="object-contain"
        />
      </span>
      <span>Filter</span>
    </div>
    <div className="flex-1">
      <SortSelect className="h-full w-full truncate border-l border-gray-500 lg:hidden" />
    </div>
  </div>
);

export default Filters;
